export class BaseModelDto {
  dataCriacao: Date;
  usuarioCriacaoId: number;
  usuarioAtualizacaoId: number;
  dataAtualizacao: Date;
}
